import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useDonation } from "../Components/DonationContext";
import { useNavigate } from "react-router-dom";
import "./ProgramsBanner.css";

// Animation variants for Framer Motion
const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const staggerItem = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const GoodHabitat = () => {
  // Data for the initiatives section for cleaner code
  const principles = [
    "Decent Housing",
    "Proper Sanitation",
    "Safe Drinking Water",
    "Green Surroundings",
    "Nature-Friendly Design",
    "Energy Efficiency",
  ];

  const { openDonation } = useDonation();
  const navigate = useNavigate();

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/assets/images/backgrounds/Good-Habitat.png)",
          }}
        ></div>
        <div className="shape1 float-bob-x">
          <img src="assets/images/shapes/page-header-shape1.png" alt="" />
        </div>
        <div className="shape2">
          <img src="assets/images/shapes/page-header-shape2.png" alt="" />
        </div>
        <Container>
          <div className="page-header__inner text-center">
            <motion.h2
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Good Habitat
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              style={{ color: "#dad2d0", fontSize: "22px", marginTop: "20px" }}
            >
              Vikash supports good habitat initiatives by promoting sustainable living environments, focusing on clean, safe, and healthy spaces for communities to thrive.
            </motion.p>
          </div>
        </Container>
      </section>

      {/* Introduction Section */}
      <section className="py-5">
        <Container>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={staggerContainer}
          >
            <Row className="align-items-center justify-content-center g-5">
              <motion.div className="col-lg-6" variants={staggerItem}>
                <h2 className="fw-bold mb-4" style={{ color: "#006633" }}>
                  The Right to a Healthy Environment
                </h2>
                <p className="lh-lg">
                  Every living being has the right to a good habitat. Vikash believes that every person should have access to decent housing, sanitation, and safe drinking water within appropriate green surroundings. We advocate for nature-friendly, energy-efficient habitats, preserving resources for posterity through our engagement with OWSSB and OTELP.
                </p>
              </motion.div>
              <motion.div className="col-lg-6" variants={staggerItem}>
                <img
                  src="/assets/images/sections/Gh1.jpg"
                  alt="A community with good habitat"
                  className="img-fluid rounded-5 shadow"
                />
              </motion.div>
            </Row>
          </motion.div>
        </Container>
      </section>

      {/* Key Principles Section (NEW) */}
      <section className="py-5 bg-light">
        <Container>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeIn}
            className="text-center mb-5"
          >
            <h2 className="fw-bold" style={{ color: "#006633" }}>
              Our Core Principles for a Good Habitat
            </h2>
            <p className="lead">
              We focus on a holistic approach to creating sustainable and thriving communities.
            </p>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={staggerContainer}
          >
            <Row className="g-4 justify-content-center">
              {principles.map((principle, index) => (
                <Col md={6} lg={4} key={index}>
                  <motion.div variants={staggerItem}>
                    <Card className="text-center p-3 border-0 shadow-sm h-100">
                      <Card.Body className="d-flex align-items-center justify-content-center">
                        <h5 className="mb-0">{principle}</h5>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </motion.div>
        </Container>
      </section>

      {/* Call To Action Section (Reusable) */}
      <section className="py-5 text-dark" style={{ backgroundColor: "#ffffffff" }}>
        <Container className="text-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeIn}
          >
            <h2 className="display-5 fw-bold mb-3">Help Build Sustainable Communities</h2>
            <p className="lead mb-4">
              Your contribution helps us promote clean, safe, and healthy living environments for families in need.
            </p>
            <Button variant="dark" size="lg" className="me-3 fw-bold" onClick={openDonation}>
              Donate
            </Button>
            <Button variant="outline-dark" size="lg" className="fw-bold" onClick={() => navigate("/interns")}>
              Join Us
            </Button>
          </motion.div>
        </Container>
      </section>

      <Footer />

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};

export default GoodHabitat;